<section id="wrapper">
    <div class="login-register" style="background-image:url(../assets/images/background/login-register.jpg);">
        <div class="login-box card">
            <div *ngIf="updated" class="card-body">
                <h5 class="text-justify">Su contraseña ha sido modificada. Por favor ingrese a la plataforma con la contraseña enviada a su dirección de email. Luego podrá modificarla desde el menú mis datos</h5>
                <a [routerLink]="'login'" class="btn btn-block btn-info btn-rounded m-t-10 m-b-10" type="submit">Ir al login</a>
            </div>
        </div>
    </div>
</section>